"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var hasher_1 = require("./hasher");
var cache_1 = require("./cache");
var noop = function () { };
exports.useSTR = function (fetcher, options) {
    var _a = React.useState(false), loading = _a[0], setLoading = _a[1];
    var _b = React.useState(), result = _b[0], setResult = _b[1];
    var _c = React.useState(), error = _c[0], setError = _c[1];
    var _d = React.useState(), fetcherURL = _d[0], setFetcherURL = _d[1];
    var _e = React.useState(), fetcherParams = _e[0], setFetcherParams = _e[1];
    var _f = React.useState(false), called = _f[0], setCalled = _f[1];
    var onSuccess = options && options.onSuccess ? options.onSuccess : noop;
    var onError = options && options.onError ? options.onError : noop;
    React.useEffect(function () {
        if (window) {
            window.addEventListener("focus", revalidateOnFocusHandler);
            window.addEventListener("visibilitychange", revalidateOnFocusHandler);
            window.addEventListener("online", revalidateOnReconnectHandler);
        }
        return function () {
            if (window) {
                window.removeEventListener("focus", revalidateOnFocusHandler);
                window.removeEventListener("visibilitychange", revalidateOnFocusHandler);
                window.removeEventListener("online", revalidateOnReconnectHandler);
            }
        };
    }, []);
    var revalidateOnFocusHandler = function () {
        if (options && options.shouldRevalidateOnFocus && fetcherURL) {
            revalidator();
        }
    };
    var revalidateOnReconnectHandler = function () {
        if (options && options.revalidateOnReconnect && fetcherURL) {
            revalidator();
        }
    };
    var getCacheEntries = function (cacheKey) {
        var errorKey = getErrorCacheKey(cacheKey);
        return [cache_1.cacheGet(cacheKey), cache_1.cacheGet(errorKey)];
    };
    var getCacheKey = function (url, params) {
        var cacheKey = "" + url + (params ? hasher_1.hasher([params]) : "");
        return cacheKey;
    };
    var getErrorCacheKey = function (cacheKey) {
        return "err@" + cacheKey;
    };
    function lazyFetch(url, params) {
        return __awaiter(this, void 0, void 0, function () {
            var key, errorKey, _a, staleResults, staleError, results, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setFetcherURL(url);
                        setFetcherParams(params);
                        setCalled(true);
                        if (!url) return [3, 5];
                        setLoading(true);
                        key = getCacheKey(url, params);
                        errorKey = getErrorCacheKey(key);
                        _a = getCacheEntries(key), staleResults = _a[0], staleError = _a[1];
                        if (!staleResults) return [3, 1];
                        setResult(staleResults);
                        setLoading(false);
                        return [3, 5];
                    case 1:
                        if (!staleError) return [3, 2];
                        setError(staleError);
                        setLoading(false);
                        return [3, 5];
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        if (options && options.loadingTimeout && options.onLoadingTimeout) {
                            setTimeout(function () {
                                if (loading) {
                                    options.onLoadingTimeout && options.onLoadingTimeout();
                                }
                            }, options.loadingTimeout);
                        }
                        return [4, fetcher(url, params)];
                    case 3:
                        results = _b.sent();
                        setResult(results);
                        cache_1.cacheSet(key, results);
                        onSuccess(results);
                        setLoading(false);
                        return [3, 5];
                    case 4:
                        err_1 = _b.sent();
                        setError(err_1);
                        cache_1.cacheSet(errorKey, err_1);
                        onError(err_1);
                        setLoading(false);
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    }
    function revalidator(url, params) {
        if (url === void 0) { url = fetcherURL; }
        if (params === void 0) { params = fetcherParams; }
        return __awaiter(this, void 0, void 0, function () {
            var cacheKey, errorKey, results, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setCalled(true);
                        if (!url) return [3, 4];
                        setLoading(true);
                        cacheKey = "" + url + hasher_1.hasher(params);
                        errorKey = getErrorCacheKey(cacheKey);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, fetcher(url, params)];
                    case 2:
                        results = _a.sent();
                        setResult(results);
                        cache_1.cacheSet(cacheKey, results);
                        onSuccess(results);
                        setLoading(false);
                        return [3, 4];
                    case 3:
                        err_2 = _a.sent();
                        setError(err_2);
                        cache_1.cacheSet(errorKey, err_2);
                        onError(err_2);
                        setLoading(false);
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    }
    function viewCache() {
        console.log(cache_1.cacheView());
    }
    return [
        lazyFetch,
        { result: result, loading: loading, error: error, revalidator: revalidator, viewCache: viewCache, called: called },
    ];
};
//# sourceMappingURL=use-str.js.map